import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsPermissionsRouteLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-permissions-redirect',
	path: '/secure/PortfolioPermissions.jspa',
};
